import { render, staticRenderFns } from "./ProductInquiryIframe.vue?vue&type=template&id=61df1030&"
import script from "./ProductInquiryIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiryIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports